<template>
  <AdminModal :title="title" @close="$emit('close')">
    <p v-if="message" class="ad-note ad-note--warn">{{ message }}</p>
    <div class="ad-field">
      <label for="reason-text">Motivo</label>
      <textarea id="reason-text" v-model="reason" class="ad-textarea" maxlength="300" placeholder="Queda registrado en la bitácora" autofocus></textarea>
      <span class="ad-hint">{{ reason.length }}/300</span>
    </div>
    <p v-if="error" class="ad-error">{{ error }}</p>
    <template #footer>
      <button type="button" class="ad-btn ad-btn--ghost" @click="$emit('close')">Cancelar</button>
      <button type="button" class="ad-btn ad-btn--danger" :disabled="busy || reason.trim().length < 3" @click="submit">
        {{ busy ? 'Guardando…' : confirmLabel }}
      </button>
    </template>
  </AdminModal>
</template>

<script setup>
import { ref } from 'vue'
import AdminModal from './AdminModal.vue'
import { errorText } from './adminFormat'

const props = defineProps({
  title: { type: String, required: true },
  message: { type: String, default: '' },
  confirmLabel: { type: String, default: 'Confirmar' },
  // async (reason) => void; si lanza error se muestra aquí.
  action: { type: Function, required: true },
})
const emit = defineEmits(['close', 'done'])

const reason = ref('')
const busy = ref(false)
const error = ref('')

async function submit() {
  busy.value = true
  error.value = ''
  try {
    await props.action(reason.value.trim())
    emit('done')
  } catch (err) {
    error.value = errorText(err)
  } finally {
    busy.value = false
  }
}
</script>